// @flow

const authMsg = (state: any = {}, action: any) => {
  switch(action.type) {
    case 'SET_AUTH_MSG':
      return {
        message: action.message,
        msgType: action.msgType,
        msgRaw: action.msgRaw,
        msgFloat: action.msgFloat,
        msgProvider: action.msgProvider,
        failed_attempts: action.failed_attempts
      };
    case 'CLEAR_AUTH_MSG':
      return {};
    default:
      return state;
  }
}

export default authMsg;



// WEBPACK FOOTER //
// ./src/reducers/authMsg.js